module.exports = __webpack_public_path__ + "img/logo.74a2f5a7.png";